'use client';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import CaseStudies from '@/components/common/case-study-section';
import ScheduleCall from '@/components/common/schedule-call';
import QaServiceFAQ from '@/components/faqs/qaservices-faq';
import Blog from '@/components/home/blog';
import ClientCarousel from '@/components/home/client-carousel';
import ClientTestimonials from '@/components/home/client-testimonials';
import MetaTags from '@/components/meta-tag/meta-tag';
import HireProcessQa from '@/components/technologies/hire-process-qa';
import QaServies from '@/components/technologies/qa-services';
import QualityAssuranceServies from '@/components/technologies/quality-assurance-services';
import TechnologyFaq from '@/components/technologies/technology-faq';
import dynamic from 'next/dynamic';
import Image from 'next/image';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));


const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <section className="hero">
                <div className="container lg:container md:mx-auto top-hero">
                    <div className="lg:grid hero-row gap-6 relative z-[1] h-full">
                        <div className="w-full">
                            <div className="inline-flex flex-col lg:items-start gap-6 hero-content justify-center h-full">
                                <h1 className="mb-0">Quality Assurance Services For World-Class Web and Mobile Applications</h1>
                                <p className="mb-0 fw-600">
                                    Embark on a transformative journey with our meticulous Quality Assurance services, ensuring
                                    excellence throughout the software development cycle.
                                </p>
                                <ScheduleCall />
                            </div>
                        </div>
                        <div className="text-center md:text-center lg:self-center hidden lg:block">
                            <Image
                                src="/img/hero/qa-hero-section.svg"
                                alt="qa hero"
                                title="qa hero"
                                className=""
                                height={446}
                                width={456}
                                loading="lazy"
                            />
                        </div>
                    </div>
                </div>
                <div className="text-center md:text-center lg:self-center lg:hidden">
                    <Image
                        src="/img/hero/qa-hero-section.svg"
                        alt="qa hero"
                        title="qa hero"
                        className=""
                        height={446}
                        width={456}
                        loading="lazy"
                    />
                </div>
                <ClientCarousel />
            </section>
            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="QA Services" />

            <ContetVideoSection title="Deliver high-performing and user-friendly software with our QA services">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Software testing is the process of evaluating and verifying that a software product or application meets
                        its requirements and performs as expected. It can help to prevent bugs, reduce development costs, and
                        improve performance.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Moweb is a software testing company that provides QA and software testing services to clients of all
                        sizes, from startups to large enterprises to Fortune 500 companies to governments. We have a team of
                        experienced and certified QA professionals who use the latest tools and techniques to test your software
                        thoroughly and identify any potential problems.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        We also work closely with our clients to understand their specific needs and provide them with customized
                        testing solutions. We have a proven track record of delivering high-quality solutions that help our
                        clients achieve success quickly.
                    </p>
                </>
            </ContetVideoSection>
            <QualityAssuranceServies />
            <QaServies />

            <HireProcessQa
                bg="bg-aiml"
                pageTitle="Our QA Process"
                desc="At Moweb, we believe that a well-defined QA process is essential for delivering high-quality software. Our QA process is designed to help you identify and fix bugs early in the development process, saving you time and money in the long run."
            />

            <TechnologyFaq title="FAQs For QA Services" bg="bg-grey">
                <QaServiceFAQ />
            </TechnologyFaq>

            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
